export const agentAttorneyMappingTo9089SectionC = {
  name: "Agent/Attorney POC Form Mapping",
  machine_name: "agent_attorney_9089_profile_mapping",
  targetFormDetailName: "Form ETA-9089",
  targetSectionName: "Requestor Point-of-Contact</br> Information",
  targetSectionLabel: "C",
  fields: [
    {
      profileFieldName: "new_profile_individual_agent_type_id",
      formTargetField: "attyAgRepType",
    },
    {
      profileFieldName: "new_profile_individual_agent_last_name",
      formTargetField: "attyAgLastName",
    },
    {
      profileFieldName: "new_profile_individual_agent_first_name",
      formTargetField: "attyAgFirstName",
    },
    {
      profileFieldName: "new_profile_individual_agent_middle_name",
      formTargetField: "attyAgMiddleName",
    },
    {
      profileFieldName: "new_profile_individual_agent_address_1",
      formTargetField: "attyAgAddress1",
    },
    {
      profileFieldName: "new_profile_individual_agent_address_2",
      formTargetField: "attyAgAddress2",
    },
    {
      profileFieldName: "new_profile_individual_agent_city",
      formTargetField: "attyAgCity",
    },
    {
      profileFieldName: "new_profile_individual_agent_country_id",
      formTargetField: "attyAgCountry",
    },
    {
      profileFieldName: "new_profile_individual_agent_state_id",
      formTargetField: "attyAgState",
    },
    {
      profileFieldName: "new_profile_individual_agent_zip",
      formTargetField: "attyAgPostalCode",
    },
    {
      profileFieldName: "new_profile_individual_agent_province",
      formTargetField: "attyAgProvince",
    },
    {
      profileFieldName: "new_profile_individual_agent_phone",
      formTargetField: "attyAgPhone",
    },
    {
      profileFieldName: "new_profile_individual_agent_phone_ext",
      formTargetField: "attyAgPhoneExt",
    },
    {
      profileFieldName: "new_profile_individual_agent_email",
      formTargetField: "attyAgEmail",
    },
    {
      profileFieldName: "new_profile_individual_agent_firm_name",
      formTargetField: "attyAgLawFirmName",
    },
    {
      profileFieldName: "new_profile_individual_agent_firm_fein",
      formTargetField: "attyAgFEIN",
    },
    {
      profileFieldName: "new_profile_individual_agent_court_name",
      formTargetField: "attyAgGoodStandingAttorney",
    },
    {
      profileFieldName: "new_profile_individual_agent_court_state_id",
      formTargetField: "attyAgGoodStandingState",
    },
    {
      profileFieldName: "new_profile_individual_agent_bar_number",
      formTargetField: "attyAgStateBarNumber",
    },
  ],
};